module.exports = __webpack_public_path__ + "static/media/img_1.e01f6481.png";